export const DEFAULT_EXCEPTION_STATUSES = [
  "Order Accepted",
  "Order Confirmed",
  "Label Created",
  "On Hold",
];

export const FALLBACK_ORDER_STATUSES = [
  "Order Accepted",
  "Order Confirmed",
  "Label Created",
  "Fulfilled",
  "Shipped",
  "In Transit",
  "Out for Delivery",
  "Delivered",
  "Cancelled",
  "On Hold",
  "Operational Hold",
  "Archived",
];

export const getDisplayTimeZone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

export const buildDefaultExceptionRange = (dayjs) => ({
  start: dayjs()
    .subtract(7, "day")
    .hour(0)
    .minute(0)
    .second(0)
    .millisecond(0),
  end: dayjs()
    .subtract(1, "day")
    .hour(15)
    .minute(0)
    .second(0)
    .millisecond(0),
});

export const buildExceptionsRequestBody = ({ statuses, start, end }) => ({
  statuses,
  start: start.toDate().toISOString(),
  end: end.toDate().toISOString(),
  timezone: getDisplayTimeZone(),
});

export const isInvalidExceptionRange = (start, end) =>
  !start ||
  !end ||
  (typeof start.isValid === "function" && !start.isValid()) ||
  (typeof end.isValid === "function" && !end.isValid()) ||
  start.valueOf() > end.valueOf();

export const resolveDefaultExceptionStatuses = (options) => {
  if (
    Array.isArray(options?.default_statuses) &&
    options.default_statuses.length
  ) {
    return options.default_statuses;
  }
  return DEFAULT_EXCEPTION_STATUSES;
};

export const getExceptionsClientId = () => localStorage.getItem("client_id");

export const getExceptionsGenerateError = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Unable to generate the exceptions report.";
